import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { AWAITINGACTIONICONS } from "@const";

@Component({
  selector: "app-awaiting-list",
  templateUrl: "./awaiting-list.component.html",
  styleUrls: ["./awaiting-list.component.scss"],
})
export class AwaitingListComponent implements OnInit, OnDestroy {
  @Input() awaitingList: any;
  @Input() couponList: any;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() openSubserviceAppt: EventEmitter<any> = new EventEmitter();
  packageTabs = [
    { code: "package", label: "Package_Service" },
    // { code: 'service', label: 'Service' },
    // { code: 'doctor', label: 'Doctor_Recommended_Service' }
  ];

  selectedPackageTab = "package";
  showPackageUnavailable = false;

  ngOnInit() {
    console.log("awaitingList", this.awaitingList);
  }

  ngOnDestroy() {
    // Clean up Swiper
  }

  public selectPackageTab(tab) {
    this.selectedPackageTab = tab.code;
  }

  public closeModal() {
    this.close.emit();
  }

  public getIcon(item) {
    let cardType = item?.viewType || "AWAITINGLISTAPPTS";
    let iconsObj =
      cardType == "AWAITINGLISTAPPTS" || cardType == "PACKAGECOUPON"
        ? AWAITINGACTIONICONS
        : AWAITINGACTIONICONS;

    return iconsObj[item?._icon || "LAB"];
  }

  public openBookSubsequentAppt(item) {
    console.log("init buy", item);
    if (item?.packageData) this.openSubserviceAppt.emit(item);
    else this.showPackageUnavailModal();
  }

  public showPackageUnavailModal() {
    this.showPackageUnavailable = true;
  }

  public closePackageUnavailModal() {
    this.showPackageUnavailable = false;
  }
}
